/**
 * Number of records per page
 * ---------------------------
 */
export const rowsPerPageOptions = [10, 20, 40, 60, 80, 100];
